import { configureStore, MiddlewareArray } from "@reduxjs/toolkit"
import reducer from "./reducer"

const store = configureStore({
  reducer,
  middleware: new MiddlewareArray(),
})

export default store
